/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestProcessTransport } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface TransportProcessingServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestProcessTransport 
     */
    transportProcessingControllerProcessTransports0(apiRequestProcessTransport: ApiRequestProcessTransport, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param apiRequestProcessTransport 
     */
    transportProcessingControllerProcessTransports1(apiRequestProcessTransport: ApiRequestProcessTransport, extraHttpRequestParams?: any): Observable<{}>;

}
